import { refreshToken } from '../../../middlewares/renew-ks';
import { RhinoError, RhinoErrorCode } from '../../error';
import { ErrorCode } from '../errorCodes';

import { KalturaApiResponse } from './type';

export function handlePhoenixErrors<Payload>(response: KalturaApiResponse<Payload>) {
  const { error } = response.result;

  if (error !== undefined) {
    let code: RhinoErrorCode = 'NETWORK_API_ERROR';
    const context = { nativeError: error };

    if (error.code === ErrorCode.InvalidKS) {
      code = 'INVALID_KS';

      refreshToken();
    }

    if (error.code === ErrorCode.ExpiredKs) {
      code = 'EXPIRED_KS';

      refreshToken();
    }
    throw new RhinoError(code, undefined, context);
  }
}
